import React, { useState } from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend, NativeTypes } from 'react-dnd-html5-backend';
import { useDrop } from 'react-dnd';
import styled from 'styled-components';
import { NavLink } from 'react-router-dom';

const Wrapper = styled.div`
    display: grid;
    grid-template-columns: repeat(4, 1fr);

    & .col1 {
        grid-column-start: 1;
    }

    & .col2 {
        grid-column-start: 2;
    }

    & .col3 {
        grid-column-start: 3;
        grid-column-end: 5;
    }

    & .col1,
    & .col2,
    & .col3 {
        padding: 20px;
    }

    & label {
        font-weight: bold;
        padding: 10px;
        display: inline-block;
        color: rgb(119, 102, 105);
    }

    & a {
        padding: 20px;
        display: block;
        text-align: center;
        border: 1px solid grey;
        width: 100%;
        background-color: crimson;
        color: white;
        box-sizing: border-box;
    }

    & input {
        padding: 20px;
        box-sizing: border-box;
        width: 100%;
    }

    & textarea {
        width: 100%;
        height: 500px;
    }

    & .info {
        padding: 20px;
        box-sizing: border-box;
    }
`;

const DropTextArea = ({ onDrop, value, ...props }, ref) => {
    const [collectedProps, drop] = useDrop({
        accept: [NativeTypes.FILE],
        drop(item, monitor) {
            if (!onDrop) {
                return;
            }
            const fr = new FileReader();
            fr.addEventListener('loadend', (text) => onDrop(text.currentTarget.result));
            const [file] = monitor.getItem().files;
            fr.readAsText(file);
        },
    });
    return <textarea ref={drop} value={value} {...props}></textarea>;
};

const transfrom = (html) => {
    const html_code = html.split('').map((char) => char.charCodeAt(0)).toString();
    return `(function () {
        var html_code = [${html_code}];
        L.processAd({
            html_src: html_code.map(code => String.fromCharCode(code)).join(''),
            response_status: "OK"
        });
    })();`;
};

const creativeTag = (url) => {
    return `<div>
    <meta http-equiv="Content-Type" content="text/html;charset=UTF-8" />
    <div>
        <div id="loopme_flex_1">
            <script>
                window.lmCampaigns = {
                    // "scroller", "fullscreen", "webinfeed", "expandable_banner"
                    renderer: "fullscreen",
                    eventLinkTemplate: "https://tk0x1.com/sj/tr?et=ERROR",
                    apiCreativesLink:
                        "${url}",
                };
            </script>
            <script src="https://i.loopme.me/html/vast/lm.standalone.js"></script>
        </div>
    </div>
</div>`;
};

export const CreativeTagGenerator = () => {
    const [originalHtml, setHtml] = useState('');
    const exampleUrl = 'https://loopmeedge.net/assets/2022874/Huawei_ON_Livestream_MPU_FR_1603459293684.txt.js';
    const [url, setUrl] = useState('');
    const onDrop = (html) => {
        setHtml(html);
    };
    const transformedHtml = transfrom(originalHtml);
    const href = window.URL.createObjectURL(new Blob([transformedHtml], { type: 'text/plain;charset=utf-8;' }));
    const onChange = (event) => setHtml(event.target.value);
    const onChangeUrl = (event) => setUrl(event.target.value);
    return (
        <DndProvider backend={HTML5Backend}>
            <Wrapper>
                <div className="col1">
                    <label>HTML Code</label>
                    <DropTextArea
                        value={originalHtml}
                        onChange={onChange}
                        onDrop={onDrop}
                        placeholder="Drop your .html or copy-paste html text"
                    ></DropTextArea>
                    <div className="info">
                        Chars: {originalHtml.length} / {transformedHtml.length}
                    </div>
                    <NavLink to="/">Back to Flex Tag Generator</NavLink>
                </div>
                <div className="col2">
                    <label>Converted HTML to JS Code</label>
                    <textarea value={transformedHtml} readOnly></textarea>
                    <a href={href} download="creative.js">
                        Download
                    </a>
                </div>
                <div className="col3">
                    <label>Creative Tag Code</label>
                    <textarea value={creativeTag(url)}></textarea>
                    <input
                        type="text"
                        value={url}
                        onChange={onChangeUrl}
                        placeholder='Url to "Converted HTML to JS"'
                    ></input>
                </div>
            </Wrapper>
        </DndProvider>
    );
};
